import { render, staticRenderFns } from "./MapiForm.vue?vue&type=template&id=0f5976a4&scoped=true&lang=pug"
import script from "./MapiForm.vue?vue&type=script&lang=js"
export * from "./MapiForm.vue?vue&type=script&lang=js"
import style0 from "./MapiForm.vue?vue&type=style&index=0&id=0f5976a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5976a4",
  null
  
)

export default component.exports